import { fixWalletGridStyling } from '../helpers/hacks.js';
import { WALLET_GRID } from '../global-constants.js';
import { loadScript } from '../utils/loadScript.js';

/**
 * Insert the My Wallet Grid widget on SRP pages
 * @param {string} walletScriptHost - Host URL for wallet scripts
 * @param {Object} config - MyWallet configuration
 */
export const insertWalletGrid = async (walletScriptHost, config) => {
	const listingsPlaceholder = document.querySelector('[data-location~="listings-placeholder-1"]');

	if (!listingsPlaceholder) {
		return;
	}

	const grids = document.querySelectorAll(WALLET_GRID);

	// Clean up any left over 'detached' grids
	grids.forEach(grid => {
		if (grid && !grid?.shadowRoot?.querySelector('div')?.shadowRoot) {
			grid.closest('div').remove();
		}
	});

	// Return early if any wallet grids are still found
	if (document.querySelectorAll(WALLET_GRID).length > 0) {
		return;
	}

	// Create wallet grid element with theme attributes
	const { walletTheme, testVariationTheming } = config;
	const div = document.createElement('div');
	const walletGrid = document.createElement(WALLET_GRID);

	if (walletTheme) {
		walletGrid.setAttribute('theme', walletTheme);
	}

	if (testVariationTheming) {
		walletGrid.setAttribute('ui', 'default');
	}

	div.appendChild(walletGrid);

	// Hide the div, not the grid!
	// When you hide `wallet-grid` itself, the My Wallet widget
	// will show loading indicators and never fully render.
	// Hiding it inside a parent div avoids this problem.
	div.classList.add('hidden');
	listingsPlaceholder.appendChild(div);

	// Load the wallet grid script
	await loadScript(`${walletScriptHost}/${WALLET_GRID}.js`, { id: 'wallet-grid-bundle' });

	// Remove the hidden class after the grid JS has loaded.
	// This timeout gives the shadow dom time to pull in the
	// CSS and apply the styling before we reveal it to the user.
	setTimeout(() => {
		window.requestAnimationFrame(() => {
			div.classList.remove('hidden');
		});
	}, 500);

	// TODO Remove this temporary hack to fix the margin/padding once
	// we can properly address it in the My Wallet code.
	fixWalletGridStyling();
}
